export type AnnotationTool = 'highlight' | 'redact'

/** A rectangle in image pixels (not screen pixels). */
export interface Annotation {
  tool: AnnotationTool
  x: number
  y: number
  width: number
  height: number
}

export interface Point {
  x: number
  y: number
}

const HIGHLIGHT_STROKE = '#facc15'
const HIGHLIGHT_FILL = 'rgba(250, 204, 21, 0.2)'
const REDACT_FILL = '#000000'

export function rectFromPoints(a: Point, b: Point) {
  return {
    x: Math.min(a.x, b.x),
    y: Math.min(a.y, b.y),
    width: Math.abs(a.x - b.x),
    height: Math.abs(a.y - b.y),
  }
}

/**
 * Paint the annotations onto the image pixels.
 *
 * Redactions go last so that no highlight drawn over them can let the
 * content show through: a redacted area is always opaque black. They are
 * also widened to whole pixels, since a fractional edge is antialiased into a
 * half-transparent strip that leaks what lies under it.
 */
export function drawAnnotations(ctx: CanvasRenderingContext2D, annotations: Annotation[]): void {
  const highlights = annotations.filter((a) => a.tool === 'highlight')
  const redactions = annotations.filter((a) => a.tool === 'redact')
  for (const a of highlights) {
    ctx.fillStyle = HIGHLIGHT_FILL
    ctx.fillRect(a.x, a.y, a.width, a.height)
    ctx.strokeStyle = HIGHLIGHT_STROKE
    ctx.lineWidth = 3
    ctx.strokeRect(a.x, a.y, a.width, a.height)
  }
  for (const a of redactions) {
    const left = Math.floor(a.x)
    const top = Math.floor(a.y)
    ctx.fillStyle = REDACT_FILL
    ctx.fillRect(left, top, Math.ceil(a.x + a.width) - left, Math.ceil(a.y + a.height) - top)
  }
}
